import { Flex, Typography } from "antd"
import DatabaseCard from "./DatabaseCard"


const MasterList =(props) => {
    const { dataList=[], getData } = props

    return (
        <>
            {
                dataList && dataList?.map(data => {
                    return (
                    <DatabaseCard data={{...data}} getData={getData} masterList={dataList} />
                    )
                })
            }
        </>

    )
}

export default MasterList